import React, { FC, useCallback, useMemo } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { ProcurementsDisplay } from 'src/models/procurements/types';
import { WorkspacePicker, RejectTendersButton } from 'src/shared';
import useOverviewMode from 'src/reactiveVars/overviewModeVar';
import { BidItemType } from '@tendium/prom-types/tender';
import { StarToggler } from 'src/common';
import { useOpenTenderPreview } from 'src/models/procurements/hooks';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { useUpdateIsStarredTender } from 'src/models/procurements/hooks';
import { TendersBoardItem } from 'src/models/procurements/TendersViews';

interface Props {
  tender: TendersBoardItem;
}

export const OverviewBoardActionsSingle: FC<Props> = ({ tender }) => {
  const { id, bid, isRejected, isStarred, name, nextId } = tender;
  const procurementTabInfo = useOverviewMode();
  const [updateTenderIsStarred] = useUpdateIsStarredTender();
  const openNextTenderPreview = useOpenTenderPreview();
  const currentSidebar = useCurrentSidebar();

  const currentWS = useMemo(() => {
    return procurementTabInfo?.tab === ProcurementsDisplay.WORKSPACE && procurementTabInfo.workspaceId;
  }, [procurementTabInfo]);

  const isMatchedTab = useMemo(() => {
    return procurementTabInfo?.tab === ProcurementsDisplay.MATCHED;
  }, [procurementTabInfo]);

  const onSetStarred = useCallback(
    (id: string, name: string, isStarred: boolean) => {
      updateTenderIsStarred(id, name, isStarred, 'OverviewBoardActionsSingle');
    },
    [updateTenderIsStarred]
  );

  const onActions = useCallback(() => {
    if (currentSidebar?.mode === SidebarMode.PROCUREMENT_INFO) {
      openNextTenderPreview(nextId);
    }
  }, [currentSidebar?.mode, openNextTenderPreview, nextId]);

  return (
    <ul className={styles.actionsSingleTender}>
      {!currentWS && (
        <li className={styles.actionSingleTender} onClick={e => e.stopPropagation()}>
          <WorkspacePicker
            originIds={bid ? undefined : [id]}
            bidIds={bid ? [bid] : undefined}
            originType={bid ? undefined : BidItemType.Procurement}
            eventSource={'OverviewBoardActionsSingle'}
            mode={'medium'}
            size={'xs'}
            onChange={onActions}
          />
        </li>
      )}

      {isMatchedTab && (
        <li className={classNames(styles.actionSingleTender, styles.rejectAction)} onClick={e => e.stopPropagation()}>
          <RejectTendersButton
            mode={'medium'}
            procurements={[{ id, isRejected }]}
            eventSource={'OverviewBoardActionsSingle'}
            onFinish={onActions}
          />
        </li>
      )}
      <li className={styles.actionSingleTender} onClick={e => e.stopPropagation()}>
        <StarToggler
          isStarred={isStarred}
          onSetStarred={onSetStarred}
          id={id}
          mode={'full'}
          className={styles.starButton}
          name={name}
        />
      </li>
    </ul>
  );
};

export default OverviewBoardActionsSingle;
